import { patchMethod } from './patch-method';
//// 使用劫持方式监听正在进行中的请求
export const observeIncomingRequests = () => {
    const incomingRequests = {};
    // 监听 XMLHttpRequest open 方法
    patchMethod(XMLHttpRequest.prototype, 'open', (origin) => {
        return function (...args) {
            const [method] = args;
            this.taggedMethod = method;
            return origin.apply(this, args);
        };
    })();
    // 监听 XMLHttpRequest send 方法
    patchMethod(XMLHttpRequest.prototype, 'send', (origin) => {
        let uniqueId = 0;
        return function (...args) {
            if (this.taggedMethod !== 'GET') {
                return origin.apply(this, args);
            }
            // uniqueId 为偶数
            uniqueId += 2;
            const reqId = uniqueId;
            incomingRequests[reqId] = Date.now();
            this.onreadystatechange = function () {
                if (this.readyState === XMLHttpRequest.DONE) {
                    // 从【进行中】表中移除
                    delete incomingRequests[reqId];
                }
            };
            return origin.apply(this, args);
        };
    })();
    // 监听 window.fetch 方法
    patchMethod(window, 'fetch', (origin) => {
        let uniqueId = 0;
        return function (...args) {
            const [request, init] = args;
            const method = request?.method || init.method;
            if (method !== 'GET') {
                return origin(...args);
            }
            return new Promise((resolve, reject) => {
                uniqueId += 2;
                const reqId = uniqueId;
                incomingRequests[reqId] = Date.now();
                origin(...args)
                    .then((value) => {
                    delete incomingRequests[reqId];
                    resolve(value);
                })
                    .catch((e) => {
                    delete incomingRequests[reqId];
                    reject(e);
                });
            });
        };
    })();
    const getIncomingRequestsTimes = () => {
        const entries = Object.entries(incomingRequests);
        return entries.map((res) => {
            return res[1];
        });
    };
    return {
        incomingRequests,
        getIncomingRequestsTimes,
    };
};
